import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        authority: 'https://external-id.factorlabs.pl/52270bb2-ed98-4b79-9314-1af808682b4b',
        clientId: '6389def3-ef32-41d3-8391-6bd09825909e',
        redirectUri: window.location.origin,
        knownAuthorities: ["https://external-id.factorlabs.pl"],
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["openid"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
